#import "../NoteFields.graphql"

mutation updateCaseNote($id: ID!, $content: String!) {
  updateCaseNote(input: { id: $id, content: $content }) {
    caseNote {
      ...NoteFields
    }
  }
}
